<template>
  <div id="contenedor-editar-presupuesto">
        <v-form ref="editarPresupuesto" v-model="formPptoValido">
      <v-card>
        <v-card-title>
          Editar Presupuesto
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-row justify="center" align="center">
          <custom-select
            cols="12" sm="12" md="2"
            class="ml-4"
            v-model="editarPresupuesto.ejercicio"
            label="Ejercicio*"
            :items="ejercicios"
            :rules="[mixReglas.requerido]"
            required>
          </custom-select>
          <custom-select
            cols="12" md="4"
            v-model="editarPresupuesto.idFuenteFinanciera"
            label="Fuente financiera*"
            :items="fuentesFinancieras"
            item-text="nombre"
            item-value="id"
            :rules="[mixReglas.requerido]"
            required>
          </custom-select>
          <custom-text-field-green
            cols="12" sm="12" md="3"
            v-model.number="editarPresupuesto.importe"
            label="Importe"
            prefix="$"
            :value="0"
            :rules="[mixReglas.notNull]"
            type="number">
          </custom-text-field-green>
          <v-col cols="12" md="2" class="py-0">
            <v-checkbox
              v-model="editarPresupuesto.esPresupuestoOriginal"
              label="Cerrar Presupuesto Original?"
              hide-details
              class="mt-0">
            </v-checkbox>
          </v-col>
        </v-row>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarPresupuesto"
            :disabled="!formPptoValido || enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixPresupuestos from './mixPresupuestos';
// import CustomTextField from '@/components/inputs/TextField.vue';
import CustomTextFieldGreen from '@/components/inputs/TextFieldGreen.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EditarPresupuesto',
  mixins: [mixPresupuestos],
  // inheritAttrs: false,
  components: {
    // CustomTextField,
    CustomTextFieldGreen,
    CustomSelect,
    // CustomTextArea,
    // CustomDatePicker,
    CustomButton,
  },
  props: {
    presupuestoEditar: Object,
  },
  data() {
    return {
      formPptoValido: false,
      presupuestoId: null,
      editarPresupuesto: {},
    };
  },
  mounted() {
    this.fetchPresupuesto();
  },
  methods: {
    fetchPresupuesto() {
      const {
        id,
        ejercicio,
        idFuenteFinanciera,
        esPresupuestoOriginal,
        importe,
      } = JSON.parse(JSON.stringify(this.presupuestoEditar));
      this.presupuestoId = id;
      this.editarPresupuesto = {
        ejercicio,
        idFuenteFinanciera,
        esPresupuestoOriginal,
        importe,
      };
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.editarPresupuesto.reset();
    },
  },
  computed: {},
};
</script>
